<template>
    <q-dialog persistent :maximized="$q.platform.is.mobile" v-model="show_modal">
        <q-card :style="$q.platform.is.mobile ? '' : 'min-width: 80vw; max-height: 80vh; z-index: 999;'">
            <q-toolbar>
                <q-toolbar-title>
                    {{ $t('terms_and_conditions') }}
                </q-toolbar-title>
            </q-toolbar>

            <q-separator />

            <q-card-section class="linkfix">
                <span v-html="term"></span>

                <div class="row">
                    <div class="col-12 text-right">
                        <q-btn color="negative" :label="$t('refuse')" icon="fal fa-ban" @click="refuse()" class="q-mr-md" />
                        <q-btn color="positive" :label="$t('accept')" icon="fal fa-check" @click="accept()" />
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'AcceptTermsAndConditions',

    i18nOptions: { namespaces: ['custom', 'common'] },

    data() {
        return {
            show_modal: false,
            terms: []
        }
    },

    computed: {
        ...mapGetters({
            accept_terms_and_conditions: 'common/accept_terms_and_conditions',
            id_user_language_selected: 'common/id_user_language_selected',
            register: 'params/register'
        }),

        term() {
            let obj = this.terms.find((obj) => { return obj.language === this.id_user_language_selected && obj.body !== null })
            if (obj) return obj.body
            else {
                let obj = this.terms.find((obj) => { return obj.body !== '' })
                if (obj) return obj.body
            }
            return ''
        }
    },

    methods: {
        getTerms() {
            this.$axios.get('/etraining_login/terms/')
	        .then(response => {
                this.terms = response.data
                this.show_modal = true
            })
            .catch(e => {
                console.log(e)
            })
        },

        refuse() {
            this.show_modal = false
            this.$store.dispatch('common/SET_ACCESS_TOKEN', ['', '', ''])

            setTimeout(() =>{
                this.$q.loading.hide()
                this.$router.replace({ name: 'login' })
            }, 700)
        },

        accept() {
            this.$q.loading.show()

            let fd = new FormData()
            fd.append('accept', true)

            this.$axios.post('/register_user/user_accept_terms_and_conditions/', fd)
            .then(response => {
                this.show_modal = false

                this.$store.dispatch('common/SET_TERMS_AND_CONDITIONS', [response.data.date_hour_accept])
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        }
    },

    mounted() {
        if (this.register.use_accept_terms === true && !this.accept_terms_and_conditions) this.getTerms()
    },

    watch: {
		accept_terms_and_conditions: function(){
            if(this.register.use_accept_terms === true && !this.accept_terms_and_conditions) {
                this.getTerms()
            }
		},
	},
}
</script>

<style>

</style>
